// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 957 ? "views-app" : chunkId) + "." + {"453":"a04ae9d0","931":"0891fd11","957":"401f780a"}[chunkId] + ".chunk.js";
};